/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-smooth/~/lodash/_freeGlobal.js
 ** module id = 645
 ** module chunks = 0
 **/